import React, { Fragment } from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Separator } from 'src/components/Separator';
import { SearchBar, SearchBarButton } from 'src/components/SearchBar';

import SettingsIcon from 'src/assets/icons/sliders.svg';

storiesOf('SearchBar', module).add('Default', () => (
  <Fragment>
    <PanelHeader>🔍 SearchBar</PanelHeader>
    <PlatformPadding vertical horizontal>
      <View>
        <SearchBar placeholder="Search" />
        <Separator size="xl" />
        <SearchBar value="Oklahoma" isLoading={true} />
        <Separator size="xl" />
        <SearchBar
          placeholder="Search"
          after={
            <SearchBarButton>
              <SettingsIcon />
            </SearchBarButton>
          }
        />
        <Separator size="xl" />
        <SearchBar placeholder="Search" showIcon={false} />
      </View>
    </PlatformPadding>
  </Fragment>
));
